<button
  pButton
  icon="fas fa-trash"
  label="{{ 'COMMON.DELETE' | translate }}"
  size="small"
  class="virtualcenter-button virtualcenter-button--danger"
  (click)="execute()"
></button>
